import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'next-themes';
import { NoSSR } from '#cutils/misc/NoSSR';
import { ThemeSelector } from './ThemeSelector';
type Props = {
  className?: string;
  forceTheme?: 'light' | 'dark';
};
function ThemeSelectorComponent(props) {
  const $ = _c(4);
  const {
    theme,
    setTheme
  } = useTheme();
  let t0;
  if ($[0] !== props || $[1] !== setTheme || $[2] !== theme) {
    t0 = <ThemeSelector theme={theme} onThemeChange={setTheme} {...props} />;
    $[0] = props;
    $[1] = setTheme;
    $[2] = theme;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
export function ThemeSelectorMenu(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <NoSSR><ThemeSelectorComponent {...props} /></NoSSR>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}